/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { themes, fonts } from '../../themes/themes';
import DashboardTimer from '../../Lottifiers/DashboardTimerr';
import CustomButtonClockInClockOut from '../CustomButtonClockInClockOut';
import './InnerBarDashboard.css';

import DashboardCurrentTimer from '../DashboardCurrentTimer';
import DashboardClockInController from '../../Modals/DashboardClockIn/DashboardClockInController';
import { useAppSelector } from '../../../infra/hooks';
import TodayBirtday from '../TodayBirthday/TodayBirthday';
import Loader from '../../Lottifiers/Loader/Loader';
import { DateField } from '../../../components';
import { baseTimeFormatting, convertDateToEpochUTC } from '../../helper';

interface PropsValues {
  data: any;
  birthdayData: any;
  setClockOut: (data: any) => void;
  status?: boolean;
  last_checkInTime?: any;
  isLoading?: boolean;
  tempLoading?: boolean;
  trans?: any;
}
const InnerBarDashboardPresenter = ({
  setClockOut,
  status,
  isLoading,
  last_checkInTime,
  tempLoading,
  trans,
}: PropsValues) => {
  const clockIn_time = useAppSelector(
    (state) => state.clockInSlice.clockIn_time,
  );
  const isEnablecheckin = useAppSelector(
    (state) => state.attendancesettingSlice.Enablecheckin,
  );
  const clockOut_time = useAppSelector(
    (state) => state.clockOutSlice.clockOut_time,
  );

  const isClockInLoading = useAppSelector(
    (state) => state.clockInSlice.clockIn_loder,
  );

  const isClockOutLoading = useAppSelector(
    (state) => state.clockOutSlice.clockOutLoader,
  );
  const [openModal, setOpenModal] = useState(false);

  const handleClockIn = () => {
    setOpenModal(true);
  };
  const handleClockOut = () => {
    //setOpenModal(true);
    const get_time = convertDateToEpochUTC(new Date());
    const checkOutTime = Math.floor(get_time / 1000);
    setClockOut({
      time: checkOutTime,
    });
  };

  return (
    <Grid container className="container_innerBar_dashboard">
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DashboardTimer />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '0.5em',
        }}
      >
        <DashboardCurrentTimer />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          style={{
            color: themes.defaultIcon,
            textAlign: 'center',
            fontSize: fonts.subtitle,
            fontFamily: fonts.fontFamily,
          }}
        >
          {trans('Current Time')}
        </Typography>
      </Grid>
      {isEnablecheckin && (
        <>
          <Grid
            item
            xs={12}
            style={{
              marginTop: '1.25em',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {status ? (
              <CustomButtonClockInClockOut
                onClick={() => handleClockIn()}
                btnLabel={trans('Clock In')}
                disabled={isClockInLoading}
              />
            ) : (
              <CustomButtonClockInClockOut
                onClick={() => handleClockOut()}
                btnLabel={trans('Clock Out')}
                disabled={isClockOutLoading}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginTop: '1.25em',
            }}
          >
            <Grid container className="clockIn-out-box">
              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                }}
              >
                <Typography>{trans('Clock In')}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-end',
                  }}
                >
                  {trans('Clock Out')}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                {clockIn_time || last_checkInTime ? (
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.primary,
                    }}
                  >
                    {clockIn_time ? (
                      <DateField
                        value={clockIn_time}
                        format={baseTimeFormatting}
                      />
                    ) : (
                      <DateField
                        value={last_checkInTime}
                        format={baseTimeFormatting}
                      />
                    )}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'flex-start',
                    }}
                  >
                    -/-
                  </Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                {clockOut_time ? (
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'center',
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.primary,
                    }}
                  >
                    <DateField
                      value={clockOut_time}
                      format={baseTimeFormatting}
                    />
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                    }}
                  >
                    -/-
                  </Typography>
                )}
              </Grid>
            </Grid>
            {isLoading || (tempLoading && <Loader height={100} width={200} />)}
          </Grid>
        </>
      )}

      <Grid container>
        <Grid item xs={12} style={{ marginTop: '2em' }}>
          <TodayBirtday />
        </Grid>
      </Grid>
      {/* Modals */}
      {openModal && (
        <DashboardClockInController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
        />
      )}
    </Grid>
  );
};

export default InnerBarDashboardPresenter;
